module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('em', [_c('strong', [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Matthew 2")])])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-10"
    }
  }, [_c('strong', [_vm._v("C. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NFANT")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESUS")]), _vm._v(", 2:1-23")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Matthew’s infancy stories are quite different from those of Luke and are peculiar to this Gospel. Matthew tells of the visit of Magi from the East, the flight of the holy family into Egypt, and Herod’s slaughter of the children of Bethlehem. He is clearly interested in the divine protection of the child Jesus, and his stories bring out the truth that God works his will despite the opposition of sinful people.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_c('em', [_c('strong', [_vm._v("1. The Visit of the Magi, 2:1-12")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("1")]), _vm._v("When Jesus was born in Bethlehem of Judea in the days of Herod the king, see, wise men from the East came to Jerusalem, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("2")]), _vm._v("saying, “Where is he who has been born King of the Jews? For we saw his star at its rising and we have come to worship him.” "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("3")]), _vm._v("Now when King Herod heard this he was troubled, and all Jerusalem with him. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("4")]), _vm._v("And he gathered all the high priests and scribes of the people and inquired of them, “Where is the Messiah to be born?” "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("5")]), _vm._v("And they said to him, “In Bethlehem of Judea; for so it is written through the prophet:")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotet"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("6")]), _vm._v(" ‘And you, Bethlehem, land of Judah,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-pl"
  }, [_c('em', [_vm._v("are by no means least among the leaders of Judah;")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-pl"
  }, [_c('em', [_vm._v("for out of you will go forth a leader")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-pl"
  }, [_c('em', [_vm._v("who will shepherd my people Israel.’”")])])]), _c('p', {
    staticClass: "blockquotet"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("7")]), _vm._v("Then Herod secretly called the wise men and ascertained from them exactly the time when the star appeared. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("8")]), _vm._v("And he sent them to Bethlehem and said, “Go, search diligently for the little child; and when you have found him tell me, so that I, too, may come and worship him. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("9")]), _vm._v("And when they had heard the king, they went on their way and, look, the star that they had seen at its rising went before them until it came and stood over the place where the little child was. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("10")]), _vm._v("And when they saw the star, they rejoiced with exceedingly great joy. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("11")]), _vm._v("And when they had come into the house, they saw the little child with Mary his mother, and they fell down and worshipped him, and they opened their treasures and offered him gifts, gold and frankincense and myrrh. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("12")]), _vm._v("And having been warned in a dream ")])]), _c('em', [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("not to return to Herod, they went back to their own country by another way.")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indent-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Many scholars have declined to see anything historical in this chapter. They point to the fact that all kinds of legends were in circulation about the infant Moses and that while the heyday of such legends came later, Josephus is evidence that wonderful stories about Moses were in circulation at this time ("), _c('em', [_vm._v("Ant.")]), _vm._v(" 2.205-7, 215-16). These scholars suggest that the author of this Gospel, moved by such stories, is manufacturing tales to bring out the greatness of Jesus."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "ft1"
    }
  }, [_vm._v("1")]), _vm._v(" Matthew is simply concerned to improve on previous models (“anything they can do we can do better”!). Others hold that the Old Testament quotations in the chapter form the clue to what went on. They think that there was a collection of testimonia circulating in the early church, passages taken from the Old Testament to show that Jesus was the Messiah and that everything in his life was done in accordance with the plan of God. The author of this Gospel, they hold, started from such a collection and manufactured fulfilments of prophecy in the birth at Bethlehem, importantly in the place of Gentiles from the first, and in general improving on the Moses stories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Clearly there is a large subjective element in such reconstructions. That there were stories about Moses does not require us to think that a writer about Jesus would manufacture similar stories (and anyway, apart from the protection of the child, the resemblances are minor). We may agree with some scholars that Matthew regards Moses as in some respects a “type” of Christ, but we can scarcely say more. The existence of testimonia, while held by many, is far from certain. And even if they did exist, we have no evidence that the writer of this Gospel used them as a basis for composing stories about Jesus. It is much more probable that he started from what he knew had happened (the account of the visit of the Magi “has on the face of it all the elements of historical probability,” "), _c('em', [_vm._v("AB)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn2",
      "id": "ft2"
    }
  }, [_vm._v("2")])])]), _vm._v(" and brought forward passages from Scripture to show that all was in accordance with prophecy than that the prophecy led to the creation of beautiful stories that lacked factual foundation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn3",
      "id": "ft3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Matthew may well have included this story to bring out the truth that Jesus is Lord of all peoples; since this is so, it was appropriate that at the time of his infancy people came from a distant Gentile country to pay their homage. In this narrative the Jews and their king are ranged against the infant Jesus, but Gentiles do him homage."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn4",
      "id": "ft4"
    }
  }, [_vm._v("4")])]), _vm._v(" There will also be the motif "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("that the purposes of God cannot be overthrown. Earthly kings like Herod may try to circumvent the divine purpose, but in the end they are always defeated. And, of course, there is the strong motif of the fulfilment of Scripture; Matthew finds events in the life of Jesus from the earliest days foretold in the holy writings.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" "), _c('em', [_vm._v("When Jesus was born")]), _vm._v(" indicates that this narrative took place after the birth of Jesus, but Matthew does not say how long after. When he was telling us about Jesus’ birth Matthew did not say where it took place, but he now informs his readers that it was at "), _c('em', [_vm._v("Bethlehem of Judea.")]), _vm._v(" This distinguishes it from another Bethlehem in Galilee (Josh. 19:15), and more importantly directs attention to the fact that it was the royal city, the place where the great David was born. This is part of the way Matthew indicates Jesus’ messiahship. The location was not important for what he had to say in chapter 1 (in the birth story he does not say where Jesus was born), but it matters a great deal for what comes before us now. The name Bethlehem means “House of Bread,” that is, a granary. Matthew speaks of Bethlehem 5 times, but Luke (twice) and John (once) are the only other New Testament writers to refer to it. It was evidently not considered an important place. It was located about 5 miles (or 8 kilometers) south of Jerusalem. Judea, here as in most places, indicates the southern part of Palestine (in contrast to Samaria, etc.); it can mean the region occupied by the Jewish nation (Luke 1:5), and it may be used in such a way as to include territory on the east of the Jordan (19:1).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("In addition to the information about the place we have a general indication of time: "), _c('em', [_vm._v("in the days of Herod the king.")]), _vm._v(" This Herod is Herod the Great, and he is correctly called “the king” (the title was sometimes accorded the tetrarch, but he was not a king; this Herod was). He was not a Jew, his father being an Idumean and his mother an Arabian, but the Romans made him King of Judea in 40 B.C. He is generally thought to have died in 4 B.C. (there is some dispute about this)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn5",
      "id": "ft5"
    }
  }, [_vm._v("5")]), _vm._v(" He was an unscrupulous tyrant, but his achievements were such that he merited the epithet “the Great.” He was a great builder and was responsible for the erection of the temple in Jerusalem, the rebuilding of Samaria (which he called Sebaste in honor of the emperor), and other significant works. And, in the words of Barclay, “He was the only ruler of Palestine who ever succeeded in keeping the peace and in bringing order into disorder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Wise men"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn6",
      "id": "ft6"
    }
  }, [_vm._v("6")])])]), _vm._v(" are not people endowed with wisdom in general, but "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("students of the stars: “a (Persian … then also Babylonian) wise man and priest, who was expert in astrology, interpretation of dreams and various other secret arts” (BAGD). "), _c('em', [_vm._v("REB")]), _vm._v(" renders the term “astrologers.” "), _c('em', [_vm._v("From the East"), _c('sup')])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#fn7",
      "id": "ft7"
    }
  }, [_vm._v("7")])]), _vm._v(" is very general; many interpreters hold that these wise men came from Babylon, and they may have done so, but we cannot be sure. Their study of the stars had led them to believe that a great leader had been born in Judea. That being so, they naturally directed their steps to Jerusalem,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn8",
      "id": "ft8"
    }
  }, [_vm._v("8")])]), _vm._v(" the capital city. These men would have been Gentiles, but Matthew gives this no emphasis. Tradition says that there were three of them, but Matthew gives no number and it appears to be a deduction from the number of the gifts. Tradition also makes them kings, but this is highly unlikely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" This sentence is the only utterance of the Magi that Matthew records. These wise men describe the leader they are looking for as "), _c('em', [_vm._v("King of the Jews")]), _vm._v(" (again in this Gospel at 27:11, 29, 37) and ask where he has been born. The words they use mean “born king,” not “born to be king,” as is often said;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn9",
      "id": "ft9"
    }
  }, [_vm._v("9")])]), _vm._v(" they are talking about what he is, not what he will be. They explain that they "), _c('em', [_vm._v("saw his star.")]), _vm._v(" Many attempts have been made to explain the phenomenon of the star, such as that there was a conjunction of planets or the explosion of a supernova or the appearance of a comet, but none carries conviction."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn10",
      "id": "ft10"
    }
  }, [_vm._v("10")])]), _vm._v(" What is clear is that the Magi reported some astronomical phenomenon that they had some way of linking with a particular king, the king of the Jews."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn11",
      "id": "ft11"
    }
  }, [_vm._v("11")])]), _vm._v(" But they do not say what the link was. It is not completely certain whether we should translate “at its rising” or “in the East,” but the expression here differs slightly from that in verse "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("1"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn12",
      "id": "ft12"
    }
  }, [_vm._v("12")]), _vm._v(" and it appears that the wise men are telling of the astronomical feature that carried conviction to them rather than calling attention to the direction in which they saw it. They say that they have come "), _c('em', [_vm._v("to worship him,")]), _vm._v(" where the verb may indicate an act of reverence toward a great man or an act of worship of God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn13",
      "id": "ft13"
    }
  }, [_vm._v("13")])]), _vm._v(" The Magi probably intended an act of homage, but Matthew may well be giving the expression its fullest meaning — the attitude of the Magi in the presence of the Baby was the attitude proper in the presence of God. The worship of the Christ was important to Matthew, and he refers to this worship 10 times (2:2, 8, 11; 8:2; 9:18; 14:33; 15:25; 20:20; 28:9, 17).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" “Having heard” is a participle indicating cause: “because he heard this, he was troubled.” Matthew does not say how Herod heard this, only that he did hear. But with such visitors no doubt reports were flying through Jerusalem, and it would be strange if some of Herod’s people did not pick up the news. There is an article with "), _c('em', [_vm._v("King Herod,")]), _vm._v(" perhaps to distance this king from “the King of the Jews.” Herod "), _c('em', [_vm._v("was troubled;")]), _vm._v(" he was an Edomite, not a Jew, and he had been made king by the Romans. The news that the Magi were bringing sounded suspiciously like the emergence of a genuine descendant of the royal line of David as a claimant to the throne (Glover points out that Herod was more interested in saving his throne than in saving his soul!). And if Herod was troubled, the whole"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn14",
      "id": "ft14"
    }
  }, [_vm._v("14")])]), _vm._v(" city was troubled with him. When Herod the Great trembled the whole city shook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" The king proceeded to gather his experts. Matthew has more references to high priests (25) and to scribes (22) than has anyone else in the New Testament. There is a problem about the exact force of the term “high priest” because in a number of places, as here, we have the plural, whereas there was only one high priest, for the office was held for life. But the rulers sometimes deposed the legitimate high priest, and the title was then applied both to the man who had formerly exercised the office (and who in the opinion of many was the real high priest) and the one who currently filled the post. J. Jeremias has shown that the term was used also to cover a number of officials such as the captain of the temple, the "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("leader of the weekly course of priests, those who had charge of financial affairs, and so on."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn15",
      "id": "ft15"
    }
  }, [_vm._v("15")]), _vm._v(" It thus covered a group of important people. Our problem is that the extension of the term from the incumbent high priest, while clear, is never defined. “Scribe” might refer to a secretary or “clerk” but could also denote a scholar who had made a study of the law, and thus the meaning might be much like our “lawyer.” In Matthew the term “scribes” is linked with “high priests” on 5 occasions (again in 16:21; 20:18; 21:15; 27:41), and it is linked with “Pharisees” 6 times (5:20; 12:38; 15:1; 23:2, 13, 15; 7 times if 23:14 be accepted). Many of the scribes were Pharisees, which is natural enough, for both groups were zealous for the law, but not all Pharisees were scribes. The passages that link scribes with the high-priestly party warn us that we should not see too strong a link with the Pharisees. The Sadducean high-priestly party needed legal experts, and it is these who are in mind in this passage. Here the one article links them closely. "), _c('em', [_vm._v("All")]), _vm._v(" shows that Herod was being thorough; he did not content himself with asking one or two outstanding men. "), _c('em', [_vm._v("Of the people")]), _vm._v(" may indicate that the scribes had a closer connection with people at large than the high priests did. The verb for "), _c('em', [_vm._v("inquired")]), _vm._v(" is in the imperfect tense, which Turner thinks “means that he scarce expected his demand to be implemented. Tentative requests are often described in that tense.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn16",
      "id": "ft16"
    }
  }, [_vm._v("16")])]), _vm._v(" The inquiry concerned the place where the Messiah (or the Christ) would be born. The article shows that the expression is used of an official title, while the present tense in the verb referring to something future puts some emphasis on the certainty that it will happen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Herod’s experts came up with a speedy reply. This is interesting, for we read in John’s Gospel of an opinion that nobody knows where the Christ will come from (John 7:27)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn17",
      "id": "ft17"
    }
  }, [_vm._v("17")])]), _vm._v(" But such views were not found among Herod’s men; for them it was quite clear that Bethlehem was the place, and they were able to quote Scripture to make their point."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn18",
      "id": "ft18"
    }
  }, [_vm._v("18")])]), _vm._v(" They thus showed, as Ridderbos points out, that their failure to believe was not due to ignorance: “Israel knew precisely where the King of the Jews would be born, but it was the Gentiles who worshiped him first” (on v. 4). When they say that it was written "), _c('em', [_vm._v("through")]), _vm._v(" the prophet they are reasoning that God is the author of Scripture; the prophet was no more than his instrument. The reference is to Micah 5:2 (with the last line from 2 Sam. 5:2; 1 Chron. 11:2). It is interesting that, although they could say immediately "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("where the Messiah would be born, they apparently did nothing about the report that the Magi brought. “They fail by being passive” (Filson)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn19",
      "id": "ft19"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" The Jewish leaders may have quoted these words from the prophet or, as Tasker thinks, they may be “an annotation by the evangelist himself” (the Jews would have kept closer to the Hebrew text). The quotation is not particularly close to either LXX or the Hebrew. For example, “land of Judah” replaces LXX “house of Ephratha,” while the Hebrew has “Bethlehem Ephratah.” But it preserves the sense."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn20",
      "id": "ft20"
    }
  }, [_vm._v("20")])]), _vm._v(" The last section, about shepherding the people, may come from 2 Samuel 5:2 or Micah 5:4. The city of "), _c('em', [_vm._v("Bethlehem")]), _vm._v(" is addressed and is then equated with "), _c('em', [_vm._v("land of Judah.")]), _vm._v(" Matthew uses "), _c('em', [_vm._v("land")]), _vm._v(" (γῆ) more often than anyone else in the New Testament except the author of Revelation, a total of 43 times. The word means “earth” and may be used of soil, ground, land, earth in contrast to heaven, or the inhabited globe. Here it is “land” in the sense of “territory.” "), _c('em', [_vm._v("By no means")]), _vm._v(" is not in the text of Micah that we know; therefore some interpreters suggest that Matthew has contradicted the prophet by inserting it. But if he did insert it, there is no real contradiction. The passage is saying that Bethlehem’s greatness consists only in that it is the birthplace of the great leader, and this is as plain in Micah as in Matthew. On the next section the translation is rather free, or else it presupposes a different Hebrew text. Our text refers to "), _c('em', [_vm._v("the leaders of Judah")]), _vm._v(" and goes on to "), _c('em', [_vm._v("a leader."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn21",
      "id": "ft21"
    }
  }, [_vm._v("21")])])]), _vm._v(" The leader is not said to be the Messiah, but the one who"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn22",
      "id": "ft22"
    }
  }, [_vm._v("22")])]), _vm._v(" was to shepherd the people certainly qualifies for the title. The verb may be used of the activities of a shepherd with a flock of animals (1 Cor. 9:7), but here the symbolic meaning emphasizes the care the leader would show as he looked after those he led.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" Armed with this information,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn23",
      "id": "ft23"
    }
  }, [_vm._v("23")])]), _vm._v(" Herod summoned the Eastern "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("sages. He wanted no undue publicity, so he called them secretly and found out from them exactly (“the exact date,” "), _c('em', [_vm._v("JB")]), _vm._v(") when the star made its appearance. He does not say why he wanted this information, but to know the time when the star appeared would obviously give an indication of the age of this new King of the Jews.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Herod apparently shared with the Magi the information he had acquired about the birthplace of the Messiah, then despatched them to Bethlehem. He instructed them to search diligently"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn24",
      "id": "ft24"
    }
  }, [_vm._v("24")]), _vm._v(" for the baby, and when they had found him to let him know where the child was so that he could go along too and worship him. It must have rung true for the Magi; they had come so far to find the new king, and the old king gave evidence of sharing their enthusiasm and their pious purpose. There is some emphasis in his "), _c('em', [_vm._v("I:")]), _vm._v(" “I, as well as you.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn25",
      "id": "ft25"
    }
  }, [_vm._v("25")])]), _vm._v(" He says that he intends"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn26",
      "id": "ft26"
    }
  }, [_vm._v("26")])]), _vm._v(" to worship as they planned to do. The word for "), _c('em', [_vm._v("little child"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn27",
      "id": "ft27"
    }
  }, [_vm._v("27")])])]), _vm._v(" may be used of children of various ages, but mostly of the young (though in familiar address it can be used even of grown men, John 21:5). Here it clearly refers to a very small child. It is perhaps surprising that he did not send someone with the Magi. But soldiers would have been inappropriate, and he may have felt that anyone linked to him would raise problems for the search. He had no reason for thinking that the Magi would not report back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("9.")]), _vm._v(" When they"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn28",
      "id": "ft28"
    }
  }, [_vm._v("28")])]), _vm._v(" heard this they set out. Matthew’s favorite "), _c('em', [_vm._v("look")]), _vm._v(" (see on 1:20) introduces a touch of vividness; he sees it as he writes. As they went on their way they saw the star again. It may be that they had given up looking for the star when they got to Jerusalem, feeling that their journey was over. But now they realized that they had still some distance to go, and once again they saw the star. We could understand the Greek to mean that the star was the one that they had seen “in the East,” but as in verse 2 it is more likely that Matthew is referring to the way the star appeared "), _c('em', [_vm._v("(at its rising)")]), _vm._v(" than to the place where they first saw it. It is not easy to understand how the star "), _c('em', [_vm._v("went before them")]), _vm._v(" nor how it "), _c('em', [_vm._v("stood")]), _vm._v(" over any one place here on earth. But Matthew is apparently saying that in some way the star kept going ahead of them until"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn29",
      "id": "ft29"
    }
  }, [_vm._v("29")])]), _vm._v(" it came to the place where"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn30",
      "id": "ft30"
    }
  }, [_vm._v("30")])]), _vm._v(" the baby was and that it then stood (still).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("10.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v(" When the Magi “caught sight of the star,”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn31",
      "id": "ft31"
    }
  }, [_vm._v("31")]), _vm._v(" they were more than a little joyful. It had been the star that had brought them to the land of Judea, and now that they were not sure of their destination within that land they were reassured by the evidence that the star was still leading them. Matthew’s expression indicates that when they saw their star again they were more than mildly pleased."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn32",
      "id": "ft32"
    }
  }, [_vm._v("32")])]), _vm._v(" “Deliriously happy” may be an overstatement, but it was something like that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("11.")]), _vm._v(" Matthew does not say that they journeyed on or that they followed the star. It was enough to say that the star appeared and went before them; it could be assumed that they followed it. Matthew resumes his story with their entry into "), _c('em', [_vm._v("the house."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn33",
      "id": "ft33"
    }
  }, [_vm._v("33")])])]), _vm._v(" There they saw the little child and his mother (in each place in this passage where the two are mentioned the child comes first, vv. 13, 14, 20, 21; Matthew’s main interest is in Jesus). Interestingly Joseph is not mentioned, though in these opening chapters he takes a more prominent place than anywhere else in the New Testament. But it would be natural to mention the mother with the baby and perhaps not as natural to include the father. The Magi prostrated themselves before the baby in lowly worship. They proceeded to open their treasure chests"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn34",
      "id": "ft34"
    }
  }, [_vm._v("34")])]), _vm._v(" and offer gifts (the verb is used of offering in general, but is especially frequent for sacrifices). Matthew specifies three gifts (from which some deduce that there were three Magi; legend has made them three kings (an idea which Bruce calls “beautiful but baseless”), and even given them names. The gifts were "), _c('em', [_vm._v("gold")]), _vm._v(" (which Matthew has in more than half its New Testament occurrences, 5 out of 9), "), _c('em', [_vm._v("frankincense")]), _vm._v(" (“a white resinous gum, obtained fr. several kinds of a certain tree in Arabia, used both medicinally and for cult purposes,” BAGD), and "), _c('em', [_vm._v("myrrh")]), _vm._v(" (“the resinous gum of the bush ‘balsamodendron myrrha,’” BAGD). Clearly all three were valuable, and together they formed a munificent gift, suitable for offering to a king. Christians have often seen symbolical meanings in them, gold for royalty, frankincense for deity, and myrrh pointing to suffering and death, but Matthew says nothing about this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("12.")]), _vm._v(" "), _c('em', [_vm._v("Warned")]), _vm._v(" is a verb used often to indicate a divine utterance, a revelation;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn35",
      "id": "ft35"
    }
  }, [_vm._v("35")])]), _vm._v(" here this divine command is given in a dream, as on a number "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("of occasions in Matthew (see on 1:20). This time there is no mention of an angel. They were instructed not to go back to Herod. No reason for this is given, but the informed reader will know that Herod was a bloodthirsty and unreliable man, and more may well have been said to the Magi than Matthew records. At any rate we are informed that they were obedient and went back home by another way.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_c('em', [_c('strong', [_vm._v("2. The Flight into Egypt, 2:13-15")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("13")]), _vm._v("Now when they had gone away, look, an angel of the Lord appears to Joseph in a dream, saying, “Get up and take the little child and his mother, and flee into Egypt, and be there till I tell you; for Herod is going to look for the little child to destroy him.” "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("14")]), _vm._v("So he got up, took the little child and his mother by night, and went away into Egypt. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("15")]), _vm._v("And he was there until Herod’s death, in order that what was spoken by the Lord through the prophet might be fulfilled, saying: “Out of Egypt I have called my son.”")])])]), _c('p', {
    staticClass: "indent-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Since there is no information about the flight into Egypt other than what we read here, some reject it. But there is nothing improbable about it. Throughout history many Jews had taken refuge in Egypt; it was almost a traditional country to which to flee when there was trouble in Palestine. There was a considerable Jewish minority in that land and, for example, there were as many as a million Jews in Alexandria and the country beyond."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn36",
      "id": "ft36"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("13.")]), _vm._v(" The Magi departed. With some vivid touches (Matthew’s characteristic "), _c('em', [_vm._v("look")]), _vm._v(" and the present tense in the verb) once again we have an angel appearing to Joseph; as before, he does so in a dream. Luke has angels appearing to Zechariah, to Mary, and to the shepherds, but there are no references to dreams. Matthew has an angel appearing in a dream several times (1:20; 2:13, 19), and when there is no angel he still speaks of divine communications taking place in dreams (1:12, 22; 27:19). "), _c('em', [_vm._v("Get up")]), _vm._v(" can refer to waking from sleep (cf. 1:24), but here it rather means getting up after one has awakened. Joseph is told to take the child and his mother (specified separately and, as elsewhere, the child mentioned first) and to seek safety in flight to Egypt. They are to stay there until"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn37",
      "id": "ft37"
    }
  }, [_vm._v("37")])]), _vm._v(" they receive further orders from on high;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn38",
      "id": "ft38"
    }
  }, [_vm._v("38")])]), _vm._v(" a divine commandment would come to "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("them in Egypt. "), _c('em', [_vm._v("For")]), _vm._v(" introduces the reason for the foregoing. Herod is going"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn39",
      "id": "ft39"
    }
  }, [_vm._v("39")]), _vm._v(" to make a search for the baby in order"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn40",
      "id": "ft40"
    }
  }, [_vm._v("40")])]), _vm._v(" to kill him. Flight was imperative.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("14.")]), _vm._v(" And flight was taken. Joseph’s actions in getting up and taking the child are described in the exact terms of the command given him (v. 13). Matthew adds that this happened "), _c('em', [_vm._v("by night.")]), _vm._v(" This probably means that Joseph acted immediately following the dream (the little family was evidently poor, there would not be a great deal involved in their preparations, and the dream would have conveyed a sense of urgency). Or it may possibly mean that he chose a time for their departure when they could leave unobserved. He went away"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn41",
      "id": "ft41"
    }
  }, [_vm._v("41")])]), _vm._v(" to Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("15.")]), _vm._v(" Joseph "), _c('em', [_vm._v("was there,")]), _vm._v(" which means that he remained in Egypt; he resided there for a time, until the death of Herod."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn42",
      "id": "ft42"
    }
  }, [_vm._v("42")])]), _vm._v(" Matthew puts some emphasis on the fulfilment of the divine purpose in his use of both the conjunction for “in order that” and his characteristic formula for introducing quotations from Scripture (for both see on 1:22). Matthew quotes from Hosea 11:1 with some variants from LXX. He uses the uncompounded form of the verb "), _c('em', [_vm._v("called,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn43",
      "id": "ft43"
    }
  }, [_vm._v("43")])])]), _vm._v(" and he has "), _c('em', [_vm._v("my son")]), _vm._v(" (as the Hebrew does) where LXX has “his children” (which means that Matthew may be making his own translation from the Hebrew). But where Hosea is referring to the Exodus, Matthew is thinking of Jesus’ flight into Egypt."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn44",
      "id": "ft44"
    }
  }, [_vm._v("44")])]), _vm._v(" Consistently he sees Scripture as fulfilled in Jesus; thus the outworking of the divine purpose is accomplished in him. Carson points out that “The NT writers insist that the OT can be rightly interpreted only if the entire revelation is kept in perspective as it is historically unfolded.” He argues that there is a pattern in revelation and that “Jesus himself is the locus of true Israel.” In a kind of Israel-Jesus typology, what could be said of the old Israel "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("could on occasion have its application to Jesus."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn45",
      "id": "ft45"
    }
  }, [_vm._v("45")]), _vm._v(" In other words, the divine purpose runs through the whole of Scripture, and it all points in some way to the climax, the coming of Christ. This is the first time that Matthew speaks of Jesus as “Son” with reference to God. That Jesus is the Son of God is a very important concept for Matthew,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn46",
      "id": "ft46"
    }
  }, [_vm._v("46")])]), _vm._v(" and it is interesting that it makes its appearance so early.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-3"
    }
  }, [_c('em', [_c('strong', [_vm._v("3. The Killing of the Children of Bethlehem, 2:16-18")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("16")]), _vm._v("Then Herod, when he had seen that he had been tricked by the wise men, was furiously angry, and he sent and killed all the boys in Bethlehem and in all the neighborhood two years of age and under in accordance with the time that he had carefully ascertained from the wise men. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("17")]), _vm._v("Then was fulfilled what was spoken through Jeremiah the prophet, saying:")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotet"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("18")]), _vm._v("“A voice was heard in Ramah,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-pl"
  }, [_c('em', [_vm._v("Weeping and great lamentation,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-pl"
  }, [_c('em', [_vm._v("Rachel weeping for her children,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-pl"
  }, [_c('em', [_vm._v("And she would not be comforted,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-pl"
  }, [_c('em', [_vm._v("Because they are no more.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Some commentators have discounted the story of the slaughter of the children, partly because it is not attested elsewhere and partly because of the character of the narrative. It is felt that such a horrifying happening as this slaughter of little boys would be referred to elsewhere if it really happened. It may fairly be countered that Herod’s declining years were so full of bloodshed that an incident of this kind might well have gone unreported in our sources. Bethlehem was a small place and may well have had no more than twenty or so boys below the age of two years. With Herod’s ferocious killings this one may well not have attracted much notice. And we cannot reject a narrative simply because only one of the Evangelists records it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("16.")]), _vm._v(" For Matthew’s characteristic "), _c('em', [_vm._v("then")]), _vm._v(" see on verse 7; here it means “at that time.” Since Bethlehem is only about six miles from Jerusalem, Herod would have expected the Magi to be back with him within a day or two of his sending them on their way. "), _c('em', [_vm._v("Seen,")]), _vm._v(" of course, is used in the sense “perceived,” “came to know,” rather than of direct sight. It is not easy to find an adequate equivalent for the word I have rendered "), _c('em', [_vm._v("tricked;")]), _vm._v(" most of its New Testament occurrences are used for the mockery of Jesus "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("after his arrest, and this is the only place in the New Testament where the sense is something like “deceive.” The verb for “make angry” is used here only in the New Testament, and it is strengthened with an adverb meaning “very much, exceedingly.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn47",
      "id": "ft47"
    }
  }, [_vm._v("47")]), _vm._v(" The combination signifies furious anger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When the verb “send” is used with other verbs “it often means simply that the action in question has been performed by someone else, like … "), _c('em', [_vm._v("he had (them) killed.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn48",
      "id": "ft48"
    }
  }, [_vm._v("48")])])]), _vm._v(" The act of killing"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn49",
      "id": "ft49"
    }
  }, [_vm._v("49")])]), _vm._v(" was performed by someone else; the responsibility belonged to Herod. He saw to it that all the boys up to two years of age were killed. This extreme reaction accords with what we know of Herod: “the cruelty of Herod had become proverbial even in Rome” (Stendahl). He had three of his own sons killed, and when he was himself near death he left orders that one member of each family should be executed on his death so that the whole nation would really be in mourning"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn50",
      "id": "ft50"
    }
  }, [_vm._v("50")])]), _vm._v(" (the orders were not carried out). The word “boy” is used here with reference to age and signifies the very young; it can also refer to descent (son), to social position (servant), to religious standing (servant of God), and in other ways. Herod’s orders covered Bethlehem itself and "), _c('em', [_vm._v("all the neighborhood;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn51",
      "id": "ft51"
    }
  }, [_vm._v("51")])])]), _vm._v(" he was taking no chances. The specification of "), _c('em', [_vm._v("two years of age and under")]), _vm._v(" corresponds to the time he had ascertained from the Magi, the time of the appearance of the star. Matthew repeats the verb he used in verse 7 for accurate inquiry. Clearly he wants his readers to be in no doubt that Herod had accurate knowledge of the time the star appeared."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn52",
      "id": "ft52"
    }
  }, [_vm._v("52")])]), _vm._v(" He was determined that no child within the area and the time frame indicated by the Magi would remain alive. We wonder that God would allow such cruelty and in the end cannot fully understand it. But we must remember, as Diétrich reminds us, “that the history of the People of God is all strewn with blood and tears…. The rage of man is unfurled upon the Elect of God…. Our own time has seen massacres equally shameless. The testimony of the evangelist is that God nonetheless pursues the purpose of salvation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("17.")]), _vm._v(" Most of this verse repeats what was said in 1:22 (where see notes). The one new thing in the formula of quotation is the attribution of this prophecy to Jeremiah (in 1:22 the prophet is not named). Matthew will later tell us that some of the Jews thought that Jesus was Jeremiah come back again (16:14), but here the name simply indicates the source of the "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("quotation. The repetition of the reference to fulfilled prophecy brings out once more a thought that means a lot to Matthew, namely that God acts in accordance with the revelation he has made in Scripture. In what happened to Jesus even in his infancy we may see the outworking of what God knew would happen.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('strong', [_vm._v("18.")]), _vm._v(" The words are from Jeremiah 31:15 (LXX 38:15), with significant differences from LXX."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn53",
      "id": "ft53"
    }
  }, [_vm._v("53")]), _vm._v(" "), _c('em', [_vm._v("A voice")]), _vm._v(" may denote an utterance expressing any one of a variety of moods, but here clearly mourning is in mind. Ramah seems to have been in the area allotted to the tribe of Benjamin and about six miles north of Jerusalem. This, of course, raises the question of why a prophecy about a voice in Ramah should be related to a happening in Bethlehem. There seems to have been a tradition that Rachel was buried near Bethlehem (though another view was that it was at Ramah, and there is a further view that the site was Zelzah, 1 Sam. 10:2). But certainly Jeremiah speaks of Rachel as weeping for her children as the Israelites went off into exile (Rachel is taken symbolically as the mother of the nation, though, of course, Leah gave birth to more of the tribes than did Rachel),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn54",
      "id": "ft54"
    }
  }, [_vm._v("54")])]), _vm._v(" and relates this to the fact that the infant Jesus went off into exile in Egypt. Matthew relates Rachel’s grief to the situation in Bethlehem after Herod’s men were through. Neither the prophet nor Matthew says whose voice was heard: the emphasis is on the mourning, not the mourners, and the language stresses the depths of the grief."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn55",
      "id": "ft55"
    }
  }, [_vm._v("55")])]), _vm._v(" It is this sort of bitter grief that Matthew sees in Bethlehem. "), _c('em', [_vm._v("Her children")]), _vm._v(" in a passage like this means “descendants,” and Rachel’s grief is such that she will"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn56",
      "id": "ft56"
    }
  }, [_vm._v("56")])]), _vm._v(" not be comforted. The reason? "), _c('em', [_vm._v("Because they are no more.")]), _vm._v(" Nothing can alter the fact of the exile and nothing can alter the fact of the killings at Bethlehem. Thus the grief remains."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn57",
      "id": "ft57"
    }
  }, [_vm._v("57")])]), _vm._v(" Yet we should add that Jeremiah’s prophecy goes on to the note of hope (Jer. 31:17) and to the making of a new covenant (Jer. 31:31-34); further, the Israelites did in time return from their exile. All "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("this points to the fact that the child Jesus would in due course come back from his exile in Egypt.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-4"
    }
  }, [_c('em', [_c('strong', [_vm._v("4. The Return from Egypt, 2:19-23")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("19")]), _vm._v("But when Herod had died, look, an angel of the Lord appears in a dream to Joseph in Egypt, "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("20")]), _vm._v("and said, “Get up, take the young child and his mother, and go into the land of Israel; for those who sought the young child’s life are dead.” "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("21")]), _vm._v("And he rose, took the young child and his mother, and went into the land of Israel.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('em', [_c('span', {
    staticClass: "verse"
  }, [_vm._v("22")]), _vm._v("Now when he heard that Archelaus was reigning over Judea in the place of his father Herod, he was afraid to go there. And having been warned in a dream, he went off into the region of Galilee. "), _c('span', {
    staticClass: "verse"
  }, [_vm._v("23")]), _vm._v("And he came and settled in a city called Nazareth, so that what was spoken through the prophets might be fulfilled, that he will be called a Nazarene.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Matthew goes on to tell his readers of the holy family’s return to Palestine and how they came to settle in Nazareth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_c('strong', [_vm._v("19.")])]), _vm._v(" It was not until "), _c('em', [_vm._v("Herod had died")]), _vm._v(" that there was any change in the situation. As long as the tyrant lived, there was danger in Palestine, but his death removed the threat. Matthew records a divine message conveyed in a dream and uses almost the same words as in 1:20 (where see notes). The exception is that he uses the present tense for "), _c('em', [_vm._v("appears")]), _vm._v(" (as in v. 13), which makes it all a little more vivid. The Evangelist is making clear that God’s power and God’s oversight extended to Egypt. His angel appeared there and gave Joseph directions.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('strong', [_vm._v("20.")]), _vm._v(" The words of the angel are almost the same as those in verse 13, the only difference being that “flee into Egypt” is replaced by "), _c('em', [_vm._v("go"), _c('sup')])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#fn58",
      "id": "ft58"
    }
  }, [_vm._v("58")]), _vm._v(" into the land of Israel.")]), _vm._v(" The return, like the flight, was undertaken at divine direction. An explanation is added, characteristically introduced by "), _c('em', [_vm._v("for;")]), _vm._v(" Matthew loves to give reasons. He does not name Herod, but refers (in Old Testament language; cf. Exod. 4:19) to the death of "), _c('em', [_vm._v("those who sought"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn59",
      "id": "ft59"
    }
  }, [_vm._v("59")])]), _vm._v(" the young child’s life."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn60",
      "id": "ft60"
    }
  }, [_vm._v("60")])])]), _vm._v(" It is only Herod who has been named as dying, but the plural here draws attention to the passing from power of those associated with the tyrant."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn61",
      "id": "ft61"
    }
  }, [_vm._v("61")])]), _vm._v(" The angel is saying that there is nothing to fear, no barrier to their going back to their own country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("21.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v(" For the fourth time we have a reference to Joseph rising and taking the young child and his mother (vv. 13, 14, and 20). Joseph was obedient. He had received the divine instruction, so he entered the land of Israel.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('strong', [_vm._v("22.")]), _vm._v(" The return to Israel was due to the divine direction, but the precise location arose from Joseph’s fear, together with another dream. Matthew says nothing about where Joseph and Mary’s home was previously, but Luke tells us that they had lived in Nazareth before going to Bethlehem (Luke 1:26; 2:4). Perhaps they would have liked to make their home in the city of David, especially in view of the circumstances attending Jesus’ birth. But there was a difficulty arising from the fact that that area was now ruled"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn62",
      "id": "ft62"
    }
  }, [_vm._v("62")]), _vm._v(" by Archelaus. This son of Herod was made ethnarch of Judea, Idumea, and Samaria when Herod died, but it did not take long for his incompetence to become apparent, and the Romans deposed him in A.D. 6. He was noted for his cruelty even in an age when cruel men were not scarce, so it is not surprising that Joseph feared to settle in this man’s dominions. His fear was reinforced by further divine direction in a dream, though on this occasion we are not told what precise instructions he was given. But the upshot of it all was that he went to "), _c('em', [_vm._v("the region"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn63",
      "id": "ft63"
    }
  }, [_vm._v("63")])]), _vm._v(" of Galilee"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn64",
      "id": "ft64"
    }
  }, [_vm._v("64")])])]), _vm._v(" to live. When Herod died, this area was in the tetrarchy of Herod Antipas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("23.")]), _vm._v(" Matthew often says “he came and did — ”; here Joseph "), _c('em', [_vm._v("came and settled,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn65",
      "id": "ft65"
    }
  }, [_vm._v("65")])])]), _vm._v(" his new home being in Nazareth."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn66",
      "id": "ft66"
    }
  }, [_vm._v("66")])]), _vm._v(" Luke locates both Joseph and Mary in this town (Luke 1:26-27; 2:4), but Matthew has not said anything so far about where either lived; he has said only that Jesus was born in Bethlehem. We should not read too much into "), _c('em', [_vm._v("city;")]), _vm._v(" the Greek language does not have a word equivalent to our “town,” and it makes do with “city” or “village.” We should understand that Nazareth was more than a hamlet, but not that it was a bustling metropolis. It was apparently not an important place; it is not mentioned in the Old Testament, the Talmud, the Midrashim, or Josephus (so BAGD). Matthew finds another fulfilment "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("of prophecy in this choice of domicile. They lived there "), _c('em', [_vm._v("so that"), _c('sup')])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#fn67",
      "id": "ft67"
    }
  }, [_vm._v("67")])]), _vm._v(" prophecy might be fulfilled. On this occasion there are some small differences from the way Matthew usually cites prophecy; thus he uses the plural "), _c('em', [_vm._v("prophets,")]), _vm._v(" he omits “saying,” and he inserts the word I have translated "), _c('em', [_vm._v("that")]), _vm._v(" (and which is taken by many interpreters as the equivalent of quotation marks, by others as meaning “because”). All this may be connected with the fact that it is not easy to find the words "), _c('em', [_vm._v("he will be called a Nazarene"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn68",
      "id": "ft68"
    }
  }, [_vm._v("68")])])]), _vm._v(" in any of the prophetical books, or for that matter, anywhere in the Old Testament."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn69",
      "id": "ft69"
    }
  }, [_vm._v("69")])]), _vm._v(" No passage even resembles this. It appears that Matthew is drawing attention to the thrust of Old Testament prophecy about the Christ rather than to any one passage. Jesus went to Galilee so that what was written about him in the prophets would be fulfilled, and we see this in his being called a Nazarene, a citizen of an obscure and unimportant town."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn70",
      "id": "ft70"
    }
  }, [_vm._v("70")])]), _vm._v(" Had he been known as “Jesus of Bethlehem” he would have had the aura of one who came from the royal city; there would have been overtones of messianic majesty. But “Jesus the Nazarene” carried with it overtones of contempt."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn71",
      "id": "ft71"
    }
  }, [_vm._v("71")])]), _vm._v(" We are to understand the prophets as pointing to one who would be despised and rejected, and Jesus as fulfilling this by his connection with obscure Nazareth.")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(". But Plummer’s comment is still relevant: “The examples cited are more remarkable for their differences than for their resemblances” (p. 12).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Cf. Allen, “The main outline of the story of the Magi is in many respects noteworthy for its historical probability.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(". For a careful examination of these scriptural quotations see R. T. France, "), _c('em', [_vm._v("NTS,")]), _vm._v(" 27 (1980-81), pp. 233-51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(". “In this chapter, Matthew introduces the major theme of his Gospel: the Jews have rejected the offer of salvation, but the Gentiles will accept it. … The Gentiles will be brought into the place which the Jews had forfeited by their unbelief, and the Church will be the Israel of the last days, destined to share in the joys of the age to come” (Fenton).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(". Our system of dating (with years B.C. and A.D.) was worked out by Dionysius Exiguus at the beginning of the sixth century; he appears to have been about four years off in his calculations.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(". μάγος seems originally to have meant a member of the tribe of the Magoi; later it was used of a member of a sacred caste who carried on with Magian practices, and then it was used of sorcerers in general (Acts 13:6, 8). We derive our word “magic” from it.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v(". ἀνατολή occurs 5 times in Matthew, twice in Luke, and 3 times in Revelation in the New Testament. The word means “rising,” specifically the rising of the sun, and thus the East. In this sense it may be singular or plural. It lacks the article, for “The points of the compass, found only with prepositions, never take the article” (BDF, 253[5]). Turner divertingly points out that we could understand the expression to mean “Wise men from the west,” for “in modern Greek the plural of "), _c('em', [_vm._v("Anatol")]), _vm._v(" is a proper name signifying ‘various parts of Asia Minor [i.e., "), _c('em', [_vm._v("Anatolia]’")]), _vm._v("” ("), _c('em', [_vm._v("Grammatical Insights,")]), _vm._v(" p. 25), which would be west, not east, of Herod’s kingdom. This could be supported by the use of the expression in Genesis 13:11, for Lot must have traveled eastward. But “from the East” is more probable, especially in view of the connection of magi with Persia and Babylon.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(". There are two Greek forms of the name Jerusalem. Matthew here uses Ἰεροσόλυμα, which he has 11 times, as against twice for Ἰερουσαλήμ. For Mark the figures are 10 and 0, for Luke 4 and 27, for John 12 and 0, for Acts 23 and 26, and for the rest of the New Testament 3 and 11. There appear to be no reasons other than personal preference for the use of either name.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(". Nigel Turner argues from the word order and the tense that we should understand this phrase as “the new-born King of the Jews.” He further thinks that “It is not so much "), _c('em', [_vm._v("who")]), _vm._v(" the Person is, as "), _c('em', [_vm._v("where")]), _vm._v(" He is, that matters to them at the moment of their question” (ET, LXVIII [1956-57], p. 122).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(". There is evidence that astral phenomena were widely held to be connected with the birth of great men; see "), _c('em', [_vm._v("TDNT,")]), _vm._v(" I, p. 505.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v(". Davies and Allison cite evidence that “at the turn of the era” there was a widespread “expectation of a world-ruler to come from Judea.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(". The earlier expression was ἀπὸ ἀνατολῶν, while here we have ἐv τῇ ἀνατολῇ). The singular and the article seem more probably to refer to an astronomical “rising.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(". προσϰυνέω is used of homage to men (18:26), to God (4:10), to the devil (4:9), to idols (Acts 7:43), to the church at Philadelphia (Rev. 3:9), and to an angel (Rev. 22:8). Abbott notes that the dative is regular in LXX and the accusative in classical Greek: “the dative emphasizes the notion of ‘prostrating oneself "), _c('em', [_vm._v("to")]), _vm._v(" a person, idol, or God,’ while the accusative means ‘adore’ without this emphasis” ("), _c('em', [_vm._v("Johannine Grammar,")]), _vm._v(" 2019). The infinitive conveys the thought of purpose. The verb occurs 13 times in this Gospel, whereas Mark and Luke each have it twice (John uses it 11 times and Revelation 24 times). In Matthew the word mostly seems to signify “worship.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(". The feminine πᾶσα is curious since Ἱεροσόλυμα is neuter. It may be that “city” is understood, but more likely the name is treated as feminine (as happens elsewhere occasionally).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('em', [_vm._v("Jerusalem in the Time of Jesus")]), _vm._v(" (London, 1967), pp. 160-81. He can say, “The chief priests permanently employed at the Temple formed a definite body who had jurisdiction over the priesthood and whose members had seats and votes on the council” (p. 180).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v(". "), _c('em', [_vm._v("Grammatical Insights,")]), _vm._v(" p. 27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(". For a discussion of the view that the place of origin of the Christ is completely unknown see my "), _c('em', [_vm._v("The Gospel according to John")]), _vm._v(" (Grand Rapids, 1971), pp. 411-12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(". Matthew introduces the words with γέγραπται, where the perfect indicates the permanence of the record. Matthew has this verb 10 times, and except for 27:37 it is always in the form γέγραπται. Deissmann shows that the term is a legal one (BS, pp. 112-14, 249-50), but here the stress is rather on the fulfilment of what is written in Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(". Mounce comments, “All this time the religious leaders of Jerusalem know from their own Scriptures where the Messiah is to be born. But not even the visit of foreign dignitaries piques their curiosity enough to travel six miles to Bethlehem to find out if there is any truth in the report” (p. 11).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft20",
      "id": "fn20"
    }
  }, [_vm._v("20")]), _vm._v(". Calvin comments, “We must always observe the rule, that as often as the Apostles quote a testimony from Scripture, although they do not render it word for word, in fact may move quite a way from it, they adapt it suitably and appropriately to the case in hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('em', [_vm._v("The leaders")]), _vm._v(" is τοῖς ἡγεμόσιν and "), _c('em', [_vm._v("a leader")]), _vm._v(" is the participle ἡγούμενος. There is not a great difference in meaning. "), _c('em', [_vm._v("NIV")]), _vm._v(" and "), _c('em', [_vm._v("REB")]), _vm._v(" have “rulers,” while "), _c('em', [_vm._v("GNB")]), _vm._v(" reads “leading cities.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft22",
      "id": "fn22"
    }
  }, [_vm._v("22")]), _vm._v(". Matthew uses ὅοτις more often than any other New Testament writer (29 times; next is Acts with 24). It often does not differ significantly from ὅς, but here a certain emphasis on the quality (who will be of such a sort) is probable.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Matthew makes a good deal of use of τότε; he has it 90 times out of its 159 New Testament occurrences (next most frequent is Acts with 21). It can refer to time past or to time future, but also “to introduce that which follows in time (not in accordance w. class. usage) "), _c('em', [_vm._v("then, thereupon”")]), _vm._v(" (BAGD, 2). BDF notes that “the use of τότε as a connective particle to introduce a subsequent event, but not one taking place at a definite time (‘thereupon’ not ‘at that time’), is unclassical” (459[2]). D. Senior cites McNeile for the information that this usage occurs 61 times in Matthew and is thus this Evangelist’s most frequent use. Senior points out that this may refer to the past or that it may be used “for current narrative” or “in reference to a future sequence of events” ("), _c('em', [_vm._v("L’ÉSM,")]), _vm._v(" p. 351, n. 28).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v(". ἀϰριβῶς, “with exactness, carefully” (AS).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft25",
      "id": "fn25"
    }
  }, [_vm._v("25")]), _vm._v(". ϰἀγώ. Matthew uses the expression 9 times, a total exceeded only by John (30) and 1 Corinthians (10; 2 Corinthians also has 9).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft26",
      "id": "fn26"
    }
  }, [_vm._v("26")]), _vm._v(". ὅπως introduces a clause of purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(". παιδίον, diminutive of παῖς. Matthew is the most frequent New Testament user of the word with 18 occurrences.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v(". οἱ δέ is the article used as a demonstrative pronoun “To indicate the progress of the narrative” (BAGD, I.3).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft29",
      "id": "fn29"
    }
  }, [_vm._v("29")]), _vm._v(". This is the conjunction ἕως (not the preposition) used with the aorist indicative, “until it stood still” (BAGD, I.1.a).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft30",
      "id": "fn30"
    }
  }, [_vm._v("30")]), _vm._v(". Matthew has no word here meaning "), _c('em', [_vm._v("place,")]), _vm._v(" simply oὗ, the genitive of ὅς, used as an adverb of place. Matthew has it 3 times.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft31",
      "id": "fn31"
    }
  }, [_vm._v("31")]), _vm._v(". M, I, p. 117.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft32",
      "id": "fn32"
    }
  }, [_vm._v("32")]), _vm._v(". σφόδρα occurs 7 times in Matthew out of its New Testament total of 11. It may be used with an adjective or a verb, here with the adjective μεγάλην.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v(". οἰϰία, which Matthew and Luke each have 25 times, more than anyone else in the New Testament (Mark is next with 18). Matthew also has οἶϰος 10 times, which Luke has 33 times, with another 25 in Acts. AS notes that οἶϰος “in Attic law denoted the whole "), _c('em', [_vm._v("estate,")]), _vm._v(" οἰϰία the "), _c('em', [_vm._v("dwelling")]), _vm._v(" only,” but adds that the distinction is not always observed in late Greek. We can scarcely say more than that Matthew prefers οἰϰία. Luke speaks of the child as in a manger (Luke 2:12, 16); the holy family may have moved, or the house may have been that of poor people with the animals living under the same roof as the family.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft34",
      "id": "fn34"
    }
  }, [_vm._v("34")]), _vm._v(". θησαυρός (9 times in Matthew out of 17 times in the New Testament) derives from τίθημι and signifies a place for putting things, for keeping them safe, then for what is kept safe, treasure.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft35",
      "id": "fn35"
    }
  }, [_vm._v("35")]), _vm._v(". χρηματίζω may have the basic meaning of “impart a revelation,” from which the idea of giving a name derives (see BAGD). Or the basic meaning may be “transact business,” from which there are two lines of development: the one refers to the anwering of questions in the course of business that leads to the concept of “answer as an oracle,” the other to getting a name (from one’s business activities; see AS). W. F. Howard held that two distinct words were involved (M, II, p. 265). See also B. Reicke, "), _c('em', [_vm._v("TDNT,")]), _vm._v(" IX, pp. 480-82.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v(". Philo, "), _c('em', [_vm._v("Flaccus")]), _vm._v(" 43.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft37",
      "id": "fn37"
    }
  }, [_vm._v("37")]), _vm._v(". This use of ἔως followed by ἄv and the aorist subjunctive is a construction used “to denote that the commencement of an event is dependent on circumstances” (BAGD, I.1.b).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft38",
      "id": "fn38"
    }
  }, [_vm._v("38")]), _vm._v(". BAGD notes as one meaning of εἰμί “to denote a sojourn, "), _c('em', [_vm._v("stay, reside”")]), _vm._v(" (I.3); that is the meaning here. ἐϰεῖ occurs more often in Matthew than in any other New Testament book (28 times). It means “there,” which may signify “to that place” (as v. 22) or “in that place,” which is the meaning here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft39",
      "id": "fn39"
    }
  }, [_vm._v("39")]), _vm._v(". μέλλω is used of futurity of various kinds, here to denote intention. “It is usually employed of an action which one intends to do, or of that which is certain, destined to take place” ("), _c('em', [_vm._v("MT,")]), _vm._v(" 72). Herod will certainly decide to look for the little child.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft40",
      "id": "fn40"
    }
  }, [_vm._v("40")]), _vm._v(". τοῦ with the infinitive normally denotes purpose, as here. Matthew uses the verb ἀπόλλυμι 19 times, a total exceeded only by Luke (27). On its use here and in 27:20 where the Jewish leaders persuade the mob to have Jesus killed, Gundry remarks, “what Herod failed to do with their help they succeeded in doing at a later time without his help.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft41",
      "id": "fn41"
    }
  }, [_vm._v("41")]), _vm._v(". ἀναχωρέω is used in the sense “withdraw,” and is often used of avoiding danger: “The connotation of ‘taking refuge’ from some peril will suit most of the NT passages remarkably well” (MM). There is a rabbinic tradition that Jesus was in Egypt ("), _c('em', [_vm._v("Sanh.")]), _vm._v(" 107b).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft42",
      "id": "fn42"
    }
  }, [_vm._v("42")]), _vm._v(". On ἕως,“until,” BAGD remarks, “a historical event forms the boundary” (II.1.a). τελευτή occurs here only in the New Testament. It means “a finishing,” “an end,” and here, of course, refers to the “end of Herod,” that is, his death.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft43",
      "id": "fn43"
    }
  }, [_vm._v("43")]), _vm._v(". Matthew has ἐϰάλεσα, LXX has μετεϰάλεσα.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft44",
      "id": "fn44"
    }
  }, [_vm._v("44")]), _vm._v(". Commenting on Hosea 11:1 J. B. Hindley remarks, “The NT use (Mt. 2:15) indicates that as Israel had forfeited their privilege of divine sonship, the prophecy would have to be fulfilled by Another (cf. Rom. 11:29)” ("), _c('em', [_vm._v("NBCR in loc.).")]), _vm._v(" There are some resemblances to Numbers 23:22; 24:8, where the nation is said to be “out of Egypt.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft45",
      "id": "fn45"
    }
  }, [_vm._v("45")]), _vm._v(". W. D. Davies can say, “Matthew sees in the history of Jesus a recapitulation of that of Israel” ("), _c('em', [_vm._v("SM,")]), _vm._v(" p. 78).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v(". Kingsbury emphasizes the significance of the concept for Matthew ("), _c('em', [_vm._v("Structure,")]), _vm._v(" pp. 40-83). While he perhaps exaggerates a little (not all see a reference to the Son of God in every place where Kingsbury finds it), he makes it clear that the understanding of Jesus as uniquely the Son of God is a major concept throughout this Gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft47",
      "id": "fn47"
    }
  }, [_vm._v("47")]), _vm._v(". The verb is θυμόω and the adverb λίαν (which Matthew uses 4 times). The aorist is ingressive with the meaning “he became angry.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft48",
      "id": "fn48"
    }
  }, [_vm._v("48")]), _vm._v(". BAGD, ἀποστέλλω, 1.d.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft49",
      "id": "fn49"
    }
  }, [_vm._v("49")]), _vm._v(". ἀναιρέω, used here only in Matthew (Acts has it 19 times), means “take up, take away” and thus “do away with, murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft50",
      "id": "fn50"
    }
  }, [_vm._v("50")]), _vm._v(". Josephus, "), _c('em', [_vm._v("Ant.")]), _vm._v(" 17.181.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft51",
      "id": "fn51"
    }
  }, [_vm._v("51")]), _vm._v(". ὅριον (6 times in Matthew, 5 in Mark, 1 in Acts only in the New Testament) is always plural in the New Testament and signifies “boundaries.” This enables it to be used to signify the region surrounding a city.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft52",
      "id": "fn52"
    }
  }, [_vm._v("52")]), _vm._v(". His verb ἀϰριβόω conveys the idea of exactness or accuracy. ϰατά is classified here as “of the norm, of similarity, homogeneity … of a standard of any other kind” (BAGD, II.5.a and γ).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft53",
      "id": "fn53"
    }
  }, [_vm._v("53")]), _vm._v(". Matthew has no equivalent of LXX’s θρήνου, while he has a πολύς that is lacking in LXX. The nouns are nominative in Matthew and genitive in LXX. He has the simple ϰλαίουσα, LXX the compound ἀποϰλαιομένη. LXX reads ἐπὶ τοῖς υἱοῖς αὐτῆ and puts it later in the sentence than Matthew’s τὰ τέϰνα αὐτῆς. LXX reads παύσασθαι for Matthew’s παραϰληθῆναι. In this verb Matthew is closer to the Hebrew than is LXX, but elsewhere LXX has the advantage. But over all in this quotation “we have evidence favouring the evangelist’s knowledge of Hebrew” (Davies and Allison).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft54",
      "id": "fn54"
    }
  }, [_vm._v("54")]), _vm._v(". In Jeremiah there is “An imaginative prophetic touch: Rachel in her grave weeping afresh over the exile of her sons Joseph and Benjamin” (F. Cawley and A. R. Millard, "), _c('em', [_vm._v("NBCR")]), _vm._v(" on Jer. 31:15-17).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft55",
      "id": "fn55"
    }
  }, [_vm._v("55")]), _vm._v(". ϰλαυθμός is found in Matthew in 7 of its 9 New Testament occurrences. It describes a loud weeping. ὀδυρμός (again in the New Testament only in 2 Cor. 7:7) signifies lamentation, which would again be done loudly.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft56",
      "id": "fn56"
    }
  }, [_vm._v("56")]), _vm._v(". The use of θέλω points to an act of will; in the greatness of her grief Rachel is not willing to be consoled.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft57",
      "id": "fn57"
    }
  }, [_vm._v("57")]), _vm._v(". Robinson has some difficulty understanding the relevance of the quotation, and reasons “it is clear that it is the tradition which has led to the selection of the proof-text, not the proof-text which is responsible for the tradition.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft58",
      "id": "fn58"
    }
  }, [_vm._v("58")]), _vm._v(". Turner sees the use of the present πορεύου “where the rule demands aor.” as “perhaps for politeness, as less peremptory” (M, III, p. 75).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft59",
      "id": "fn59"
    }
  }, [_vm._v("59")]), _vm._v(". Burton takes this as an example of the use of the present participle as an imperfect “to denote a continued action antecedent to that of the principal verb” ("), _c('em', [_vm._v("MT,")]), _vm._v(" 127). They kept seeking his life.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft60",
      "id": "fn60"
    }
  }, [_vm._v("60")]), _vm._v(". ψυχή, which Matthew uses 16 times, the most in any one book in the New Testament, has a wide range of meaning and is frequently used in the sense “soul.” Here, however, it clearly means this earthly life.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft61",
      "id": "fn61"
    }
  }, [_vm._v("61")]), _vm._v(". Unless it is what Turner calls “The allusive pl.,” which “is sometimes used when a class or variety rather than number is stressed” (M, III, pp. 25-26).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft62",
      "id": "fn62"
    }
  }, [_vm._v("62")]), _vm._v(". Matthew’s verb βασιλεύει strictly refers to the rule of a king. Herod left Judea, Idumea, and Samaria to him with the title “king,” so Matthew’s statement is accurate for this time. But the Romans refused him this title until he proved worthy of it, which he never did. It is perhaps relevant also that Archelaus ruled “in the place of” (ἀντι) his father. Josephus uses the same verb of this man ("), _c('em', [_vm._v("Life")]), _vm._v(" 5).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft63",
      "id": "fn63"
    }
  }, [_vm._v("63")]), _vm._v(". μέρος means “part”; in the plural it can denote the parts of a country and thus “region, district.” With this meaning it is followed by a genitive.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft64",
      "id": "fn64"
    }
  }, [_vm._v("64")]), _vm._v(". Galilee is the Greek form of "), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("גָּליל")]), _vm._v(" “circle, district,” and was used of “the district of the Gentiles”; “after the Exile the northern part of Palestine, bounded by Syria, Sidon, Tyre, Ptolemais, Carmel, the plain of Jezreel, and the Jordan” (BAGD derives these limits from Josephus, "), _c('em', [_vm._v("War")]), _vm._v(" 3.35-40).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft65",
      "id": "fn65"
    }
  }, [_vm._v("65")]), _vm._v(". The verb ϰατοιϰέω means “settle down” and signifies a permanent dwelling as against sojourning (παροιϰέω).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft66",
      "id": "fn66"
    }
  }, [_vm._v("66")]), _vm._v(". There is variation in the name: Ναζαρά, Ναζαρέτ, and Ναζαρέθ are all found, and in some MSS Ναζαράθ and Ναζαράτ. Howard comments, “The exact Greek name of this obscure little place, which was never heard of till the Gospel story was current, might easily fluctuate in oral and written sources” (M, II, p. 149).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft67",
      "id": "fn67"
    }
  }, [_vm._v("67")]), _vm._v(". ὅπως occurs 17 times in Matthew, the most in any one book. He uses it to bring out the sense of purpose, as here.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft68",
      "id": "fn68"
    }
  }, [_vm._v("68")]), _vm._v(". Matthew and John use the form Ναζωραῖος, which Luke has once in his Gospel and invariably in Acts. Mark always has Ναζαρηνός, and Luke has it twice. There is no difference in meaning. BAGD points out that “linguistically the transition fr. Ναζαρέτ to Ναζωραῖος is difficult … and it is to be borne in mind that Ναζωραΐος meant someth. different before it was connected w. Nazareth.” But the transition was certainly made, for there can be no doubt that in the New Testament the word means “from Nazareth.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft69",
      "id": "fn69"
    }
  }, [_vm._v("69")]), _vm._v(". The most favored suggestions point to "), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("נצר")]), _vm._v(" (a “shoot” or “branch,” Isa. 11:1) and to "), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("נזיר")]), _vm._v(" (“Nazirite,” Num. 6:2). But, despite the confident assertions of many commentators, it is not easy to understand the connection between the branch or the Nazirite and the present passage. Cf. Hamann, “The word sounds a little like ‘Nazirite’, but the two should not be confused, for they are quite different in derivation and meaning.” Matthew’s own explanation is that the term refers to Nazareth, and for an understanding of his Gospel it is best to accept his explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft70",
      "id": "fn70"
    }
  }, [_vm._v("70")]), _vm._v(". Cf. R. Knox, “No such prophecy has survived to us. But an obscure village is often regarded by its more important neighbours as typical of an unfashionable or provincial outlook; cf. Jn. 1.46. The prophecy (Is. 53.3) that our Lord would be despised by men was fulfilled when his contemporaries spoke of him scornfully as ‘a prophet from Nazareth’ (like our ‘wise men of Gotham’)” (The "), _c('em', [_vm._v("New Testament,")]), _vm._v(" p. 2, n. 4). Zahn has a somewhat similar view, but he takes ὅτι as causal, “because.” Lenski, Ridderbos, and Plummer also take it as causal.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#ft71",
      "id": "fn71"
    }
  }, [_vm._v("71")]), _vm._v(". “When Christians were referred to in Acts as the ‘Nazarene sect’ (24:5), the expression was meant to hurt” (Carson).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b2ebf32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Chapter02.vue
// module id = 81
// module chunks = 0